export default __webpack_public_path__ + "static/media/p-get-started-img-01.1618488e.png";